import isChunkLoadError from './isChunkLoadError';
import { logInfo } from './loggers';

/**
 * Returns true and logs an info event if the error is a ChunkLoadError, so callers
 * can skip their logError path for transient CDN chunk failures that are not product bugs.
 */
export default function handleChunkLoadError(
  error: Error,
  location: string,
  context?: Record<string, any>
): boolean {
  if (!isChunkLoadError(error)) return false;

  logInfo(location, { error: error.message, ...context });

  return true;
}
